
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import {IMovementsReport} from "@/modules/Report/Movements/interfaces/movements-report.interface";
  import {Barrier} from "@/modules/barriers/interfaces/barrier.interface";
  import {httpResource} from "@/resources/http.resource";
  import {IBalance} from "@/modules/Payment/interfaces/balance.interface";

  @Component({
    components: {
      AppDialog,
    },
  })
  export default class DecodeMoneyPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'allPages', dialogName: 'decodeMoneyPopup' };
    decodeText = '';

    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }

    async mounted() {
      await this.decodeMoney();
    }

    async decodeMoney() {
      let asyncAction = async () => {
        const action = Barrier.Action.GateMake;
        const params: any = {
          command: Barrier.Commands.SumInfo,
          movId: this.payloadPopup.movId,
          carNumber: this.payloadPopup.carNumber,
        };
        let response = await httpResource.httpAction({ action, params });
        this.decodeText = response.data.result.sumInfo;
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    async reCalc() {
      let asyncAction = async () => {
        const action = IBalance.Action.ReCalcSaldo;
        const params: any = {
          movId: this.payloadPopup.movId,
          carNumber: this.payloadPopup.carNumber,
        };
        await httpResource.httpAction({ action, params });
        this.$notify({ title: 'Успешно', message: 'Сумма зафиксирована', type: 'success' });
        await this.onClose();
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }
  }
